import React from "react";


const ErrorLabel = props => {
  const { message, className } = props;

  return (
    <>
      <div className={`errorText  ${className}`} style={{marginTop:'3px'}}>
        {/* <img  src={ExclamationIcon} /> */}
        {message}
      </div>
    </>
  );
};

export default ErrorLabel;
